export const reviews = [
  {
    _id: 1,
    name: 'Terence',
    img: 'https://images.pexels.com/photos/3823200/pexels-photo-3823200.jpeg?auto=compress&cs=tinysrgb&w=800',
    content: 'Colin was very helpful and replaced our boiler without any stress and for a great price. Would highly recommend his services to friends and family!',
    stars: [1, 2, 3, 4, 5]
  },
  {
    _id: 2,
    name: 'Christina',
    img: 'https://images.pexels.com/photos/5579584/pexels-photo-5579584.jpeg?auto=compress&cs=tinysrgb&w=800',
    content: 'Our heating was not working and this service was extremely helpful in diagnosing the issues and gave us a great price to fix the issues.',
    stars: [1, 2, 3, 4, 5]
  },
  {
    _id: 3,
    name: 'Leah',
    img: 'https://images.pexels.com/photos/1642883/pexels-photo-1642883.jpeg?auto=compress&cs=tinysrgb&w=800',
    content: 'Very communicative and responsive. Installed new air conditioning units. Highly recommend this local business.',
    stars: [1, 2, 3, 4, 5]
  }
]